import React, { useEffect, useState } from 'react';
import { Table, Button, Input, Space, Typography, message, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import {useNavigate, useSearchParams} from 'react-router-dom';
import axios from 'axios';
import {SERVER_BASE_URL} from "../Constants";
import Cookies from "js-cookie";

const { Title } = Typography;

const CreateOrJoinTeam = () => {
    const [searchParams] = useSearchParams();
    const competitionId = searchParams.get('competitionId');

    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showCreateInput, setShowCreateInput] = useState(false);
    const [newTeamName, setNewTeamName] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        if (competitionId) {
            fetchTeams(competitionId).then();
        }
    }, [competitionId]);

    const fetchTeams = async (id) => {
        setLoading(true);
        try {
            const response = await axios.get(SERVER_BASE_URL + `api/teams/for-competition/${id}`);
            console.log(response);
            setTeams(response.data.teams);
        } catch (err) {
            message.error('Failed to load teams');
        } finally {
            setLoading(false);
        }
    };

    const token = Cookies.get("token");

    const handleJoinTeam = async (teamId) => {
        try {
            await axios.post(SERVER_BASE_URL + `api/teams/join/${teamId}`, {},{
                headers: { Authorization: `Bearer ${token}` }
            });
            message.success('Joined team successfully');
            navigate('/profile')
        } catch (err) {
            message.error('Could not join team');
        }
    };

    const handleCreateTeam = async () => {
        if (!newTeamName.trim()) {
            message.error('Team name cannot be empty');
            return;
        }

        try {
            await axios.post(SERVER_BASE_URL +`api/teams/create`, {
                team_name: newTeamName.trim(),
                competition_id: competitionId,
            },
                {
                    headers: { Authorization: `Bearer ${token}` }
                });
            message.success('Team created');
            navigate('/profile')
        } catch (err) {
            message.error('Failed to create team');
        }
    };

    const tableData = teams.map(team => ({
        key: team.team_id,
        team_id: team.team_id,
        team_name: team.team_name,
    }));

    if (!competitionId) {
        return <div>No competition selected.</div>;
    }

    return (
        <div style={{ maxWidth: 600, margin: 'auto', padding: 24 }}>
            <Title level={3}>Join an Existing Team</Title>

            {loading ? (
                <Spin />
            ) : (
                <Table
                    className="team-table"
                    pagination={{ pageSize: 3 }}
                    dataSource={tableData}
                    columns={[
                        {
                            title: 'Team Name',
                            dataIndex: 'team_name',
                            key: 'team_name',
                            sorter: (a, b) => a.team_name.localeCompare(b.team_name),
                            defaultSortOrder: 'ascend'
                        },
                        {
                            title: 'Action',
                            key: 'action',
                            render: (_, team) => (
                                <Button type="primary" onClick={() => handleJoinTeam(team.team_id)}>
                                    Join
                                </Button>
                            ),
                        },
                    ]}
                />

            )}

            <div style={{ marginTop: 32 }}>
                <Space direction="vertical" style={{ width: '100%' }}>
                    {!showCreateInput ? (
                        <Button
                            icon={<PlusOutlined />}
                            type="dashed"
                            block
                            onClick={() => setShowCreateInput(true)}
                        >
                            Create a New Team
                        </Button>
                    ) : (
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Input
                                placeholder="Enter new team name"
                                value={newTeamName}
                                onChange={(e) => setNewTeamName(e.target.value)}
                            />
                            <Space>
                                <Button type="primary" onClick={handleCreateTeam}>
                                    Create
                                </Button>
                                <Button onClick={() => {
                                    setShowCreateInput(false);
                                    setNewTeamName('');
                                }}>
                                    Cancel
                                </Button>
                            </Space>
                        </Space>
                    )}
                </Space>
            </div>
        </div>
    );
};

export default CreateOrJoinTeam;
